import React, { FC } from 'react';
import Image from 'next/image';
import successCheck from '@/public/assets/icons/success-check.svg';

export interface AlertProps {
  message: string;
}

const Alert: FC<AlertProps> = ({ message }) => {
  return (
    <div className="border-success border-solid border rounded bg-kelly-green-tint p-4 flex space-x-2">
      <Image
        src={successCheck}
        alt="Check icon"
        height={20}
        width={20}
        className="h-[20px] w-[20px]"
      />
      <p>{message}</p>
    </div>
  );
};

export default React.memo(Alert);
